import firebaseApp from "./config";

const recapcha = (functionCall, button) => (
  // here button is id of function call event or button i.e 'sign-in-button'
  window.recaptchaVerifier = new firebaseApp.auth.RecaptchaVerifier(button, {
    'size': 'invisible',
    'callback': function(response) {
      // console.log("recapcha response", response);
      // reCAPTCHA solved, allow signInWithPhoneNumber.
      functionCall();
    }
})
);

export {recapcha};